// ignore-string-externalization

import {
  screenSmMax,
  spacer16,
  spacer24,
  spacer32,
  spacer48,
  spacer40,
  spacer72,
  spacer56,
  screenXxsMax,
  cssColorValue,
  screenSmMin,
} from '@spotify-internal/encore-web-v6';
import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  background-color: ${cssColorValue('backgroundBase')};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacer56} ${spacer40} 0px;
  // no encore spacer variable for 96
  gap: 96px;
  // 991px and below
  @media (max-width: ${screenSmMax}) {
    padding: ${spacer48} ${spacer40} 0px;
    gap: ${spacer40};
    align-items: flex-start;
  }
  @media (max-width: ${screenXxsMax}) {
    padding: ${spacer48} ${spacer16} 0px;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer24};
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  // 991px and below
  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
    // no encore spacer variable for 54
    gap: 54px;
  }
  @media (max-width: ${screenXxsMax}) {
    gap: ${spacer48};
  }
  .logo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: ${spacer72};
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    width: 15%;
    // 991px and below
    @media (max-width: ${screenSmMax}) {
      width: 100%;
    }
  }
  .columns {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    gap: ${spacer24};
    flex: none;
    align-self: stretch;
    flex-grow: 0;
    width: 58%;
    // 991px and below
    @media (max-width: ${screenSmMax}) {
      order: 1;
      width: 100%;
    }
    // 479px and below
    @media (max-width: ${screenXxsMax}) {
      order: 1;
      width: 100%;
      flex-direction: column;
      gap: ${spacer48};
    }
  }
  .columns > .column {
    display: flex;
    flex-direction: column;
    padding: 0px;
    gap: ${spacer24};
    flex: none;
    flex-grow: 0;
    &:first-of-type {
      order: 1;
      @media (max-width: ${screenSmMax}) {
        order: 0;
      }
      // calculation accounts for gap
      width: calc((28% - 16px));
      // between 768px and 991px
      @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
        // calculation accounts for gap
        width: calc(38% - 16px);
      }
      // 479px and below
      @media (max-width: ${screenXxsMax}) {
        width: 100%;
      }
    }
    :not(:first-of-type),
    :not(:last-of-type) {
      order: 2;
      @media (max-width: ${screenSmMax}) {
        order: 1;
      }
      // calculation accounts for gap
      width: calc(28% - 16px);
      // between 768px and 991px
      @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
        // calculation accounts for gap
        width: calc(38% - 16px);
      }
      // 479px and below
      @media (max-width: ${screenXxsMax}) {
        width: 100%;
      }
    }
    &:last-of-type {
      order: 3;
      @media (max-width: ${screenSmMax}) {
        order: 2;
      }
      // calculation accounts for gap
      width: calc(44% - 16px);
      // between 768px and 991px
      @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
        // calculation accounts for gap
        width: calc(24% - 16px);
      }
      // 479px and below
      @media (max-width: ${screenXxsMax}) {
        width: 100%;
      }
    }
  }
  .social {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0px;
    gap: ${spacer16};
    flex: none;
    order: 4;
    align-self: stretch;
    flex-grow: 1;
    // calculation accounts for gap
    width: calc(24% - 16px);
    // anything smaller than 991px
    @media (max-width: ${screenSmMax}) {
      order: 2;
      align-items: flex-start;
      width: 100%;
    }
  }
`;

export const SubFooter = styled.div`
  border-top: solid 1px ${cssColorValue('decorativeSubdued')};
  display: flex;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  gap: ${spacer24};
  flex: none;
  flex-direction: row;
  padding: ${spacer32} 0px ${spacer32} 0px;
  // 991px and below
  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
    padding: ${spacer24} 0px ${spacer24} 0px;
  }
  .language {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    gap: ${spacer32};
    flex: none;
    order: 1;
    flex-grow: 0;
    // 991px and below
    @media (max-width: ${screenSmMax}) {
      width: 100%;
      flex: none;
      order: 0;
      flex-grow: 0;
      justify-content: flex-end;
    }
  }
  .copyright-policies {
    flex: none;
    order: 0;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    // no encore spacer value for 36px
    gap: 36px;
    // 991px and below
    @media (max-width: ${screenSmMax}) {
      width: 100%;
      justify-content: space-between;
      gap: ${spacer24};
      order: 1;
      align-self: stretch;
    }
  }
`;
